<div>
    @if (currentMode === loginPageModesEnum.login) {
        <div>
            <ws-ace-loader
                [show]="!showLogin"
                [hasOverlay]="true"
                [darkOverlay]="false"
                [zIndex]="1054"
            ></ws-ace-loader>
            @if (showLogin) {
                <div class="col-md-6 offset-sm-3 col-xl-4 offset-lg-4">
                    <h2>Login</h2>
                    <div class="login-panel">
                        @if (error) {
                            <div class="alert alert-danger" data-qa="login-error">{{ error }}</div>
                        }
                        @if (warning) {
                            <div class="alert alert-warning" data-qa="login-warning">{{ warning }}</div>
                        }
                        <form name="form" role="form" (ngSubmit)="login()">
                            <div class="mb-4">
                                <label for="username">Username</label>
                                <input
                                    type="text"
                                    name="username"
                                    id="username"
                                    class="form-control"
                                    data-qa="login-username"
                                    [ngClass]="{ 'is-invalid': userName.dirty && userName.errors?.required }"
                                    [formControl]="userName"
                                    required
                                />
                                @if (userName.dirty && userName.errors?.required) {
                                    <span class="help-block" data-qa="login-username-error">
                                        Username is required
                                    </span>
                                }
                            </div>
                            <div class="mb-4">
                                <label for="password">Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    class="form-control"
                                    data-qa="login-password"
                                    [ngClass]="{ 'is-invalid': password.dirty && password.errors?.required }"
                                    [formControl]="password"
                                    required
                                    autocomplete="off"
                                />
                                @if (password.dirty && password.errors?.required) {
                                    <span class="help-block" data-qa="login-password-error">
                                        Password is required
                                    </span>
                                }
                            </div>
                            <div class="mb-4">
                                <span
                                    class="anchor-style"
                                    data-qa="login-forgot-password-link"
                                    (click)="currentMode = loginPageModesEnum.getToken; error = ''"
                                >
                                    Forgot password?
                                </span>
                            </div>
                            @if (isSSOEnabled) {
                                <div class="mb-4">
                                    <span class="anchor-style" data-qa="login-sso-link" (click)="switchToSSOMode()">
                                        Login using SSO
                                    </span>
                                </div>
                            }
                            <div class="form-actions float-end mt-2">
                                <button
                                    type="submit"
                                    class="ace-btn btn-primary"
                                    data-qa="login-button"
                                    [disabled]="password.invalid || userName.invalid"
                                >
                                    Login
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </div>
                </div>
            }
        </div>
    }

    @if (currentMode === loginPageModesEnum.getToken) {
        <div class="col-md-6 offset-sm-3 col-xl-4 offset-lg-4">
            <h2>Password recovery</h2>
            <div class="login-panel">
                @if (error) {
                    <div class="alert alert-danger" data-qa="login-error">{{ error }}</div>
                }
                @if (warning) {
                    <div class="alert alert-warning" data-qa="login-warning">{{ warning }}</div>
                }
                @if (passwordResetEmailHasBeenSentMessage) {
                    <div>
                        <div class="mb-4 help-block">
                            <strong>
                                <h3 data-qa="login-reset-sent-msg">{{ passwordResetEmailHasBeenSentMessage }}</h3>
                            </strong>
                        </div>
                        <div class="mb-4" style="margin-top: 30px">
                            <button
                                type="button"
                                data-qa="login-back-to-login-btn"
                                (click)="currentMode = loginPageModesEnum.login; error = ''"
                                class="ace-btn btn-primary"
                            >
                                Go back to login page
                            </button>
                        </div>
                    </div>
                }
                <ws-ace-loader [show]="showSpinner" [hasOverlay]="false"></ws-ace-loader>
                @if (!(showSpinner || passwordResetEmailHasBeenSentMessage)) {
                    <form name="form-password-recovery-get-url" role="form" (ngSubmit)="sendPasswordResetToken()">
                        <div class="mb-4">
                            <label>Username or email</label>
                            <input
                                type="text"
                                name="usernameOrEmail"
                                id="usernameOrEmail"
                                class="form-control"
                                data-qa="login-username"
                                [formControl]="usernameOrEmail"
                                required
                            />
                        </div>
                        <div class="form-actions float-start" style="margin-top: 10px">
                            <button
                                type="button"
                                data-qa="login-cancel-btn"
                                (click)="currentMode = loginPageModesEnum.login"
                                class="ace-btn btn-primary"
                                >Cancel
                            </button>
                        </div>
                        <div class="form-actions float-end" style="margin-top: 10px">
                            <button
                                type="submit"
                                class="ace-btn btn-primary"
                                data-qa="login-get-recovery-url-btn"
                                [disabled]="usernameOrEmail.invalid"
                            >
                                Get password recovery URL
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </form>
                }
            </div>
        </div>
    }

    @if (currentMode === loginPageModesEnum.useToken) {
        <div class="col-md-6 offset-sm-3 col-xl-4 offset-lg-4">
            <h2>Password reset</h2>
            <div class="login-panel">
                @if (error) {
                    <div class="alert alert-danger" data-qa="login-error">{{ error }}</div>
                }
                @if (warning) {
                    <div class="alert alert-warning" data-qa="login-warning">{{ warning }}</div>
                }
                @if (showGetNewTokenButton) {
                    <div class="mb-4">
                        <button
                            type="button"
                            data-qa="login-get-new-link-btn"
                            (click)="currentMode = loginPageModesEnum.getToken; error = ''"
                            class="ace-btn btn-primary"
                            >Get a new link
                        </button>
                    </div>
                }
                <ws-ace-loader [show]="showSpinner" [hasOverlay]="false"></ws-ace-loader>
                @if (!(showSpinner || showGetNewTokenButton)) {
                    <form name="passwordResetForm" class="form-horizontal" role="form" (ngSubmit)="resetPassword()">
                        <new-password
                            [showCurrent]="false"
                            [(passwords)]="passwordObj"
                            [(passwordsValid)]="passwordsValid"
                            [alreadyUsed]="alreadyUsed"
                        >
                        </new-password>
                        <div class="form-actions float-start" style="margin-top: 10px">
                            <button
                                type="button"
                                data-qa="login-cancel-btn"
                                (click)="goToLogin()"
                                class="ace-btn btn-primary"
                            >
                                Cancel
                            </button>
                        </div>
                        <div class="form-actions float-end mt-2">
                            <button
                                type="submit"
                                data-qa="login-reset-password-btn"
                                class="ace-btn btn-primary"
                                [disabled]="!passwordsValid"
                                >Reset Password
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </form>
                }
            </div>
        </div>
    }

    @if (currentMode === loginPageModesEnum.selectSSODomain) {
        <div class="col-md-6 offset-sm-3 col-xl-4 offset-lg-4">
            <h2>Login Using SSO</h2>
            <div class="login-panel">
                @if (error) {
                    <div class="alert alert-danger" data-qa="login-error">{{ error }}</div>
                }
                @if (warning) {
                    <div class="alert alert-warning" data-qa="login-warning">{{ warning }}</div>
                }
                <ws-ace-loader [show]="showSpinner" [hasOverlay]="false"></ws-ace-loader>
                @if (!showSpinner) {
                    <form name="form-select-sso-domain" role="form" (ngSubmit)="initializeSSOLogin()">
                        <div class="mb-4">
                            <label>Select your login domain</label>
                            <input
                                type="text"
                                name="loginDomain"
                                id="loginDomain"
                                class="form-control"
                                data-qa="login-domain"
                                spellcheck="false"
                                [formControl]="loginDomain"
                                required
                            />
                        </div>
                        <div class="form-actions mt-2">
                            <label>
                                <input
                                    type="checkbox"
                                    style="vertical-align: middle"
                                    data-qa="login-remember-domain-checkbox"
                                    [(ngModel)]="rememberSSODomain"
                                    (change)="setRememberSSODomain()"
                                />
                                <span
                                    style="
                                        font-weight: normal;
                                        vertical-align: middle;
                                        margin-left: 5px;
                                        margin-top: 4px;
                                        display: inline-block;
                                    "
                                >
                                    Remember my selection
                                </span>
                            </label>
                        </div>
                        <div>
                            <span
                                >For example, if your email address is john.doe&#64;company.com, company.com is the
                                domain</span
                            >
                        </div>
                        <div class="form-actions float-start mt-2">
                            <button
                                type="button"
                                data-qa="login-cancel-btn"
                                (click)="cancelSelectSSODomain()"
                                class="ace-btn btn-primary"
                            >
                                Cancel
                            </button>
                        </div>
                        <div class="form-actions float-end mt-2">
                            <button
                                type="submit"
                                class="ace-btn btn-primary"
                                data-qa="login-button"
                                [disabled]="loginDomain.invalid"
                            >
                                Login
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </form>
                }
            </div>
        </div>
    }
    @if (currentMode === loginPageModesEnum.awaitingSSO) {
        <div class="col-md-6 offset-sm-3 col-xl-4 offset-lg-4">
            <h2>Login Using SSO</h2>
            <div class="login-panel">
                <form name="form-awaiting-sso" role="form">
                    <div>
                        <span>Login with your company's provider using the pop-up</span>
                        <button
                            type="button"
                            data-qa="login-cancel-btn"
                            class="ace-btn btn-sm btn-primary"
                            (click)="currentMode = loginPageModesEnum.selectSSODomain"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    }

    @if (currentMode === loginPageModesEnum.homeRealmDiscovery) {
        <div class="col-md-6 offset-sm-3 col-xl-4 offset-lg-4">
            <h2>Login To PropertyPoint</h2>
            <div class="login-panel">
                @if (error) {
                    <div class="alert alert-danger" data-qa="login-error">{{ error }}</div>
                }
                @if (warning) {
                    <div class="alert alert-warning" data-qa="login-warning">{{ warning }}</div>
                }
                <ws-ace-loader [show]="showSpinner" [hasOverlay]="true"></ws-ace-loader>
                @if (!showSpinner) {
                    <form name="form-home-realm-discovery" role="form" (ngSubmit)="submitHomeRealmDiscovery()">
                        <div class="mb-4">
                            <label>Email Address</label>
                            <input
                                type="text"
                                name="username"
                                id="username"
                                class="form-control"
                                data-qa="login-username"
                                spellcheck="false"
                                [formControl]="userName"
                                required
                            />
                        </div>
                        <div class="checkbox">
                            <label>
                                <input
                                    type="checkbox"
                                    data-qa="login-remember-email-checkbox"
                                    class="ws-vertical-align-middle"
                                    [(ngModel)]="rememberSSOEmail"
                                />
                                Remember my email
                            </label>
                        </div>
                        <div class="form-actions float-end mt-2">
                            <button
                                type="submit"
                                class="ace-btn btn-primary"
                                data-qa="login-button"
                                [disabled]="userName.invalid"
                            >
                                Login
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </form>
                }
            </div>
        </div>
    }

    @if (currentMode === loginPageModesEnum.migratePassword) {
        <div>
            <ws-ace-loader [show]="!showLogin" [hasOverlay]="true" [darkOverlay]="false"></ws-ace-loader>
            @if (showLogin) {
                <div class="col-md-6 offset-sm-3 col-xl-4 offset-lg-4">
                    <h2>Login To PropertyPoint</h2>
                    <div class="login-panel">
                        @if (error) {
                            <div class="alert alert-danger" data-qa="login-error">{{ error }}</div>
                        }
                        @if (warning) {
                            <div class="alert alert-warning" data-qa="login-warning">{{ warning }}</div>
                        }
                        <!-- <sd-loading-spinner ng-show="showSpinner"></sd-loading-spinner> -->
                        @if (!showSpinner) {
                            <form name="form-login-migrate" role="form" (ngSubmit)="login()">
                                <div class="mb-4">
                                    <label for="password">Password</label>
                                    <input
                                        type="password"
                                        name="password"
                                        id="password"
                                        class="form-control"
                                        data-qa="login-password"
                                        [ngClass]="{ 'is-invalid': password.dirty && password.errors?.required }"
                                        [formControl]="password"
                                        required
                                        autocomplete="off"
                                    />
                                    @if (password.dirty && password.errors?.required) {
                                        <span class="help-block" data-qa="login-password-error"
                                            >Password is required</span
                                        >
                                    }
                                </div>
                                <div class="form-actions float-start mt-2">
                                    <button
                                        type="button"
                                        data-qa="login-cancel-btn"
                                        (click)="currentMode = loginPageModesEnum.homeRealmDiscovery"
                                        class="ace-btn btn-primary"
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div class="form-actions float-end mt-2">
                                    <button
                                        type="submit"
                                        class="ace-btn btn-primary"
                                        data-qa="login-button"
                                        [disabled]="password.dirty && password.errors?.required"
                                    >
                                        Login
                                    </button>
                                </div>
                                <div class="clearfix"></div>
                            </form>
                        }
                    </div>
                </div>
            }
        </div>
    }

    @if (currentMode === loginPageModesEnum.loginWithToken) {
        <div>
            <ws-ace-loader
                [show]="!showLogin"
                [hasOverlay]="true"
                [darkOverlay]="false"
                [zIndex]="1054"
            ></ws-ace-loader>
            @if (showLogin) {
                <div class="col-md-6 offset-sm-3 col-xl-4 offset-lg-4">
                    <h2>Login with Token</h2>
                    <div class="login-panel">
                        @if (error) {
                            <div class="alert alert-danger" data-qa="login-error">{{ error }}</div>
                        }
                        @if (warning) {
                            <div class="alert alert-warning" data-qa="login-warning">{{ warning }}</div>
                        }
                        <form name="form" role="form" (ngSubmit)="login()">
                            <div class="mb-4">
                                <label for="tokenType">Token Type</label>
                                <select
                                    name="tokenType"
                                    id="tokenType"
                                    class="form-control form-select form-select-sm"
                                    data-qa="login-token-type"
                                    [formControl]="tokenType"
                                    required
                                >
                                    <option [value]="tokenTypesEnum.clientCredential">Client Credential Key</option>
                                    <option [value]="tokenTypesEnum.accessToken">Access Token</option>
                                    <option [value]="tokenTypesEnum.refreshToken">Refresh Token</option>
                                </select>
                            </div>
                            @if (tokenType.value == tokenTypesEnum.clientCredential) {
                                <div class="mb-4">
                                    <label for="username">Client Id</label>
                                    <input
                                        type="text"
                                        name="username"
                                        id="username"
                                        class="form-control"
                                        data-qa="login-username"
                                        [ngClass]="{ 'is-invalid': userName.dirty && userName.errors?.required }"
                                        [formControl]="userName"
                                        required
                                    />
                                    @if (userName.dirty && userName.errors?.required) {
                                        <span class="help-block" data-qa="login-username-error">
                                            Client Id is required
                                        </span>
                                    }
                                </div>
                                <div class="mb-4">
                                    <label for="password">Secret Key</label>
                                    <input
                                        type="password"
                                        name="password"
                                        id="password"
                                        class="form-control"
                                        data-qa="login-password"
                                        [ngClass]="{ 'is-invalid': password.dirty && password.errors?.required }"
                                        [formControl]="password"
                                        required
                                        autocomplete="off"
                                    />
                                    @if (password.dirty && password.errors?.required) {
                                        <span class="help-block" data-qa="login-password-error">
                                            Secret Key is required
                                        </span>
                                    }
                                </div>
                            }
                            @if (tokenType.value == tokenTypesEnum.accessToken) {
                                <div class="mb-4">
                                    <label for="tokenValue">Token</label>
                                    <input
                                        type="text"
                                        name="tokenValue"
                                        id="tokenValue"
                                        class="form-control"
                                        data-qa="login-token-value"
                                        [ngClass]="{ 'is-invalid': tokenValue.dirty && tokenValue.errors?.required }"
                                        [formControl]="tokenValue"
                                        required
                                    />
                                    @if (tokenValue.dirty && tokenValue.errors?.required) {
                                        <span class="help-block" data-qa="login-token-value-error">
                                            Token is required
                                        </span>
                                    }
                                </div>
                            }
                            @if (tokenType.value == tokenTypesEnum.refreshToken) {
                                <div class="mb-4">
                                    <label for="tokenValue">Token</label>
                                    <input
                                        type="text"
                                        name="tokenValue"
                                        id="tokenValue"
                                        class="form-control"
                                        data-qa="login-token-value"
                                        [ngClass]="{ 'is-invalid': tokenValue.dirty && tokenValue.errors?.required }"
                                        [formControl]="tokenValue"
                                        required
                                    />
                                    @if (tokenValue.dirty && tokenValue.errors?.required) {
                                        <span class="help-block" data-qa="login-token-value-error">
                                            Token is required
                                        </span>
                                    }
                                </div>
                            }
                            @if (
                                tokenType.value == tokenTypesEnum.refreshToken ||
                                tokenType.value == tokenTypesEnum.accessToken
                            ) {
                                <div class="mb-4">
                                    <label for="sessionSignature">Session Signature</label>
                                    <input
                                        type="text"
                                        name="sessionSignature"
                                        id="sessionSignature"
                                        class="form-control"
                                        data-qa="login-session-signature"
                                        [formControl]="sessionSignature"
                                    />
                                </div>
                            }
                            <div class="form-actions float-end mt-2">
                                <button
                                    type="submit"
                                    class="ace-btn btn-primary"
                                    data-qa="login-button"
                                    [disabled]="isTokenLoginSubmitDisabled()"
                                >
                                    Login
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </div>
                </div>
            }
        </div>
    }
</div>
